"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Jumbotron["default"];
  }
});
var _Jumbotron = _interopRequireDefault(require("react-bootstrap/lib/Jumbotron"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Jumbotron.js
// module id = 6403
// module chunks = 25